/* eslint-disable no-bitwise */

/**
 * Generates an Id that is compatible with the mesh network.  The first portion, characters 0-7 is a partial timestamp,
 * and the last portion is derived from some property that can be derived from either the mesh packet or some other use case specific
 * constant.  This allows us to reassemble the Id reliably on the mesh receiver side.
 *
 * For PTT: We use a combination of a partial timestamp and the user Id for encoding purposes at the mesh level.
 * For Channel Paging: We use a combination of a partial timestamp and the channel Id for encoding purposes at the mesh level.
 * @param partialId
 * @param timestampMs
 * @returns string
 */
export function generateMeshCompatibleId(partialId: string, timestampMs: number = Date.now()) {
    const ts = getTempMeshId(timestampMs).toString(16).padStart(8, '0');
    return `${ts}${partialId.substring(8)}`;
}

/**
 * Masks a timestamp down to the numeric mesh ID range used for temporary (not-yet-synced) channels.
 */
export function getTempMeshId(timestampMs: number): number {
    return timestampMs & 0x1f_ff_ff_ff;
}

export function getMeshPttId(pttId: string | number, userId: string) {
    if (typeof pttId === 'number') pttId = pttId.toString(16).padStart(8, '0');
    return `${pttId.substring(0, 8)}${userId.substring(8)}`;
}
